"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalServerError = void 0;
const http_error_1 = require("./http-error");
class InternalServerError extends http_error_1.HttpError {
    constructor(message = "Internal Server Error") {
        super(message, 500, "errors/internal");
    }
}
exports.InternalServerError = InternalServerError;
